@let _productInfo = productInfo();

@if (_productInfo?.media?.url || _productInfo?.media?.urlTwicPic) {
  <sd-banner
    [media]="_productInfo?.media"
    [imgRatio]="isMobile$ ? imageRatioMobile : imageRatio()"
    [isFit]="true"
    [hasBorder]="imageHasBorder"
  />
}
@if (_productInfo?.title || _productInfo?.price) {
  <div class="c__body">
    @if (_productInfo?.brandLogoTitle){
      <div class="c__item-logo">
        <sd-banner class="c__brand-logo-title"
          [isFit]="true"
          [media]="_productInfo.brandLogoTitle"
        />
      </div>
    }
    @if (_productInfo?.title) {
      <sd-title [customClass]="isMobile$ ? 'is-body-s' : 'is-body-l'" [titleLevel]="titleLevel()">
        {{ _productInfo?.title }}
      </sd-title>
    }
    @if (_productInfo?.subtitle && !isSimplified()) {
      <p class="c__description is-caption">
        {{ _productInfo?.subtitle }}
      </p>
    }
    @if (_productInfo?.price) {
      <div class="c__price">
        <p
          [class]="isMobile$ ? 'is-body-s' : 'is-body-l'"
          [ngClass]="{
            'is-recommended-price': _productInfo?.recommendedPrice || _productInfo?.isDiscountWithRecommendedPrice,
            'is-discounted': !_productInfo?.isDiscountWithRecommendedPrice || !_productInfo?.discountedPrice
          }"
        >
          @if (_productInfo?.discountedPrice) {
            <span class="is-visually-hidden">
              {{ 'product.price.reducedPrice' | translate}}
            </span>
            {{ _productInfo?.discountedPrice }}
            <sd-converted-price class="is-double-currency" [price]="_productInfo?.discountedPrice" />
          }
          @if (!_productInfo?.isDiscountWithRecommendedPrice || !_productInfo?.discountedPrice) {
            <span [ngClass]="{'is-old-price': _productInfo?.discountedPrice, 'is-read-only': isReadOnly()}">
              @if (_productInfo?.discountedPrice && (!_productInfo?.recommendedPrice || !_productInfo?.isDiscountWithRecommendedPrice)) {
                <span class="is-visually-hidden">
                  {{ 'product.price.initialPrice' | translate}}
                </span>
              }
              <span class="is-bold" [ngClass]="{'is-price-through': _productInfo?.discountedPrice}">
                {{ _productInfo?.price }}
                <sd-converted-price
                  class="is-double-currency"
                  [displayComponent]="!_productInfo?.discountedPrice"
                  [price]="_productInfo?.price"
                />
              </span>
            </span>
          }
          <span [ngClass]="{'is-recommended-price': _productInfo?.recommendedPrice || _productInfo?.isDiscountWithRecommendedPrice}">
            @if ((!_productInfo?.isDiscountWithRecommendedPrice && _productInfo?.recommendedPrice) || (_productInfo?.isDiscountWithRecommendedPrice && _productInfo?.discountedPrice)) {
              <span class="c__recommended-price-wrapper">
                <span class="c__recommended-price-text is-overline">{{ 'product.price.recommendedPrice' | translate }}*</span>
                <button type="button" role="button" class="is-reset is-full-area c__recommended-price-button" (click)="onOpenRecommendedPriceModal()">
                  <sd-icon name="icon-help" />
                </button>
                <span class="c__recommended-price is-caption is-bold">
                  {{ !_productInfo?.isDiscountWithRecommendedPrice ? _productInfo?.recommendedPrice : _productInfo?.price }}
                </span>
              </span>
            }
          </span>
        </p>
        @if (_productInfo?.isTaxesIncluded) {
          <p class="c__taxes-included is-caption">
            {{'product.taxesIncluded' | translate }}
          </p>
        }
        @if (_productInfo?.quantity && isReadOnly()) {
          <span class="c__quantity-label is-overline">
            {{ "product.quantityLabel" | translate }} <b>{{ _productInfo?.quantity }}</b>
          </span>
        }
      </div>
    }
    @if (_productInfo?.url) {
      <sd-link
        [indexFollow]="indexFollow()"
        customClass="c__link is-full-area"
        [link]="{url: _productInfo.url}"
        (clicked)="onClick($event)"
      >
        <span class="is-label is-visually-hidden">
          {{ 'navigation.discoverIt' | translate }}
        </span>
      </sd-link>
    }
  </div>
}

@if (!isReadOnly()) {
  <sd-form select
    [items]="itemQty"
    [labelTitle]="'product.a11y.quantity' | translate: { productName: _productInfo?.title, productCode: _productInfo?.code }"
    [labelHidden]="true"
    valueKey="value"
    nameField="selectQuantity"
    #quantitySelector
    [isSmall]="true"
    (valueChanged)="notifyQuantity()"
    [selectedValue]="{ value: updatedSelectedValue() }"
    libelleKey="value"
    [disabled]="quantityDisabled()"
  />
}

@if (_productInfo?.bundle?.length > 0) {
  <ul class="c__bundle" sd-list-block>
    @for (bundle of _productInfo?.bundle; track bundle) {
      <li [ngClass]="{'is-free': bundle?.isFree}">
        <sd-banner
          [media]="bundle?.media"
          [hasAltText]="false"
          [isFit]="true"
          class="c__media-wrapper {{ imageHasBorder ? 'has-border' : '' }}"
          [imgRatio]="isMobile$ ? imageRatioMobile : bundle?.isFree ? imageRatioEnum.r3_2 : imageRatio()"
        />
        @if (!bundle?.isFree) {
          <sd-title customClass="brand--h6 is-light">
            {{ bundle?.title }}
          </sd-title>
        }
        @if (bundle?.isFree) {
          <div class="c__free-gift-wrapper">
            <sd-title>
              {{ 'product.free.gift' | translate }}
            </sd-title>
            <p class="is-caption is-medium">
              {{ bundle?.title }}
            </p>
          </div>
        }
        @if (bundle?.url) {
          <sd-link
            [indexFollow]="indexFollow()"
            customClass="is-full-area"
            (clicked)="onClick($event)"
            [link]="{ url: bundle.url }"
          >
            <span class="is-visually-hidden">
              {{ bundle?.title }}
            </span>
          </sd-link>
        }
      </li>
    }
  </ul>
}
